module.exports = __webpack_public_path__ + "static/media/default-banner.c6885dad.svg";